var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button, InlineNotification, Text } from '@ui';
import { unignoreEquipmentType } from '../shared/api';
import { translatorFor } from '../shared/i18n';
const t = translatorFor('equipment_mapping');
export function IgnoredTypes({ urls, ignoredTypes, onChange }) {
    const [busyId, setBusyId] = useState(null);
    const [error, setError] = useState(false);
    if (ignoredTypes.length === 0)
        return null;
    const unignore = (stEquipmentTypeId) => __awaiter(this, void 0, void 0, function* () {
        setBusyId(stEquipmentTypeId);
        setError(false);
        try {
            onChange(yield unignoreEquipmentType(urls, stEquipmentTypeId));
        }
        catch (_a) {
            setError(true);
        }
        finally {
            setBusyId(null);
        }
    });
    return (React.createElement("div", { className: "service-titan-settings__problem-body" },
        React.createElement(Text, { variant: "small", as: "h3" }, t('ignored_heading')),
        React.createElement("ul", { className: "service-titan-settings__plain-list" }, ignoredTypes.map((type) => (React.createElement("li", { key: type.stEquipmentTypeId, className: "service-titan-settings__list-row" },
            React.createElement(Text, { variant: "body", as: "span" }, type.stEquipmentType),
            React.createElement(Button, { variant: "tertiary", disabled: busyId === type.stEquipmentTypeId, onClick: () => {
                    void unignore(type.stEquipmentTypeId);
                } }, t('unignore')))))),
        error && React.createElement(InlineNotification, { variant: "error" }, t('unignore_failed'))));
}
export default IgnoredTypes;
